import React from "react";
import { useNavigate } from "react-router-dom";
import "../css/login.css";
import logo from "../img/db.png"; // Make sure the file name matches exactly

const Login = () => {
  const navigate = useNavigate();

  // 🔙 Back Button Function
  const handleBack = () => {
    navigate("/"); // Go back to previous page
  };

  // 🔐 Handle Login Form Submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    const username = e.target[0].value.trim();
    const password = e.target[1].value.trim();

    if (!username || !password) {
      alert("Please enter both username and password.");
      return;
    }

    try {
      const response = await fetch("https://auxititpt.org/Backend/login_auth.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });

      const data = await response.json();

    if (data.status === "success") {
  // Save auth session
  localStorage.setItem("authToken", "AUXILIUM_ADMIN_AUTH");

  alert("Login successful!");
  navigate("/dashboard", { replace: true });
}
else {
        alert("Invalid username or password.");
      }
    } catch (error) {
      console.error("Error connecting to server:", error);
      alert("Server connection error. Please check if PHP backend is running.");
    }
  };

  return (
    <div className="login-container">
      {/* 🔙 Back Button */}
      <button className="back-btn" onClick={handleBack}>
        <i className="fa fa-arrow-left"></i> Back
      </button>

      {/* Left Section */}
      <div className="login-left">
        <img src={logo} alt="Auxilium ITI Logo" className="login-logo" />
        <h2 className="brand-text">AUXILIUM ITI</h2>
      </div>

      {/* Right Section */}
      <div className="login-right">
        <div className="login-box">
          <h2 className="welcome-text">Welcome</h2>
          <p className="sub-text">Please login to Admin Dashboard.</p>

          <form onSubmit={handleSubmit}>
            <div className="form-group mb-3">
              <input
                type="text"
                className="form-control"
                placeholder="Username"
                required
              />
            </div>
            <div className="form-group mb-3">
              <input
                type="password"
                className="form-control"
                placeholder="Password"
                required
              />
            </div>

            <button type="submit" className=" login-btn">
              Login
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
